// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"82e0a8fa","453":"56f46472","722":"cf68d8bd","732":"48d94485","885":"c835eaf1"}[chunkId] + ".chunk.js";
};